<div *ngIf="!loading">
  <div class="portal-container">
    <div class="top-container">
      <div class="mt-3 flex justify-center items-center flex-col">
        <div class="w-11/12">
<!--          <div style="padding: 300px 50px 50px;"></div>-->
          <app-card-selection [paymentMethodsCard]="paymentMethodsCards" [oneClickEnabled]="oneClickEnabled" [cols]="cols" [mobile]="mobile" [sessionData]="sessionData"></app-card-selection>
          <app-init-click-to-pay (maskedDataEventEmitter)="setMaskedEvent($event)" *ngIf="clickToPayMethod" [cols]="cols" [mobile]="mobile" [sessionData]="sessionData"></app-init-click-to-pay>
          <app-other-selection [maskedData]="maskedData" [paymentMethodsOther]="paymentMethodsOther" [cols]="cols" [mobile]="mobile" [sessionData]="sessionData"></app-other-selection>
        </div>
      </div>
    </div>

    <div class="bottom-container w-full flex flex-row items-end pl-0 pr-0 sm:pl-2 sm:pr-2 pb-0 justify-between absolute bottom-0 mat-typography">
      <p class="text-md sm:text-lg ml-2 text-gray-800 mb-2">This is a secure transaction</p>
      <img *ngIf="!hidePgLogo" class="sm:h-14 h-12 mr-2 mb-0 sm:mr-2 sm:mb-1" src="assets/icons/Icons/Group.png">
    </div>
  </div>
</div>

